import { css } from '@/styled-system/css';

export const wrapper = css({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 'calc(100vh - 42px)',
  lg: {
    minHeight: 'calc(100vh - 56px)',
  },
});

export const main = css({
  flex: 1,
});
